import type { ReactNode } from 'react'

import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown'
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark'
import Button from '@space-core/components/button'
import Modal from '@space-core/components/modal'
import ModalBody from '@space-core/components/modalBody'
import ModalHeader from '@space-core/components/modalHeader'
import { useMediaQuery } from '@space-core/hooks'
import { ScreenSizes } from '@space-core/styles'

import { focusVisible } from '@space-core/styles'

import Icon from '@space-shell/common/components/icon'
import { useModal } from '@space-shell/common/hooks/useModal'
import clsx from 'clsx'
import styled from 'styled-components'

import ViewButtonItem from './viewButtonItem'

const Title = styled.span`
  max-width: 12.5rem;
`

const CloseButton = styled.button`
  ${focusVisible}
`

const ModalBodyContainer = styled.div`
  max-height: 60vh;
`
type ViewButtonProps = {
  fieldAction: {
    label: string
    title?: string
    isDisable?: boolean
  }
  modal: {
    title: string
    description: string
  }
  className?: string
  children: ({ onModalClose }: { onModalClose: () => void }) => ReactNode
}

const ViewButton = ({ fieldAction, modal, className, children }: ViewButtonProps) => {
  const { isModalOpen, handleClose, handleOpen } = useModal()
  const isMobile = useMediaQuery(`(max-width: ${ScreenSizes.lg})`)

  const containerClasses = clsx('_d-flex _align-items-center _text-truncate', className)

  return (
    <div className={containerClasses}>
      {!isMobile && <span className='_text-gray-900 _mr-4'>{fieldAction.label}</span>}
      <Button
        variation='default'
        className='_d-flex _align-items-center _justify-content-between _text-gray-900 _text-truncate'
        disabled={fieldAction.isDisable}
        onClick={handleOpen}>
        <Title className='_text-truncate'>{fieldAction.title}</Title>
        <Icon icon={faChevronDown} className='_ml-2' />
      </Button>

      <Modal show={isModalOpen} onClose={handleClose}>
        <ModalHeader className='_px-5 _pt-5 _pb-0'>
          <div className='_text-gray-900 _d-flex _justify-content-between _align-items-center'>
            <h2 className='_text-5'>{modal.title}</h2>
            <CloseButton
              className='_bg-transparent _border-0 _text-5 _text-gray-900 _line-height-sm _cursor-pointer _align-self-start'
              data-test='closeViewAsModalButton'
              onClick={handleClose}>
              <Icon icon={faXmark} />
            </CloseButton>
          </div>
        </ModalHeader>
        <ModalBody className='_p-0'>
          <ModalBodyContainer className='_overflow-y-scroll _p-5'>
            <p className='_text-gray-700 _mb-5'>{modal.description}</p>
            <div>{children({ onModalClose: handleClose })}</div>
          </ModalBodyContainer>
        </ModalBody>
      </Modal>
    </div>
  )
}

ViewButton.Item = ViewButtonItem

export default ViewButton
